import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { inject, observer } from 'mobx-react';
import { NavigationContainer } from '../NavigationContainer';
import { SiteBanner } from '../SiteBanner';
import { Header, Footer } from '../../components';
import { Notifications } from '../../components/App/Notifications';
import { AsyncLoader } from '../../components/Common/AsyncLoader';
import { LoadingSpinner } from '../../components/Common/LoadingSpinner';
import {
  STORE_AUTH,
  STORE_CATEGORY,
  EVENT_HANDLED_NAV,
  STORE_NAV_MENU,
  STORE_NOTIFICATION
} from '../../constants';
import {
  AuthStore,
  CategoryStore,
  NavMenuStore,
  NotificationStore
} from '../../stores';
import './style.css';

export interface LayoutProps extends RouteComponentProps<{}> {
  /* [STORE_NAV_MENU]: NavMenuStore; */
  DevTools: React.ComponentClass<{}>;
}

export interface LayoutState {
  /* empty */
}

@inject(STORE_AUTH)
@inject(STORE_CATEGORY)
@inject(STORE_NAV_MENU)
@inject(STORE_NOTIFICATION)
@observer
export class Layout extends React.Component<LayoutProps, LayoutState> {
  public async UNSAFE_componentWillMount(): Promise<void> {
    const authStore = this.props[STORE_AUTH] as AuthStore;
    const navMenuStore = this.props[STORE_NAV_MENU] as NavMenuStore;

    // Make sure we load nav (+ categories) before we try loading user data
    await navMenuStore.fetchNavMenuItems();

    try {
      // Try to fetch user data  when the app loads
      await authStore.getUserData(true);
    } catch (ex) {
      // Do nothing - we're not logged in from a previous session
    }
  }

  render() {
    const categoryStore = this.props[STORE_CATEGORY] as CategoryStore;
    const navMenuStore = this.props[STORE_NAV_MENU] as NavMenuStore;
    const notificationStore = this.props[
      STORE_NOTIFICATION
    ] as NotificationStore;

    return (
      <div className="layout" onClick={this.onBodyClick}>
        <Header
          navigationItems={navMenuStore.headerNavigationItems}
          onToggleNav={navMenuStore.toggle}
        />
        <AsyncLoader
          className="app-content-loader layout-body-wrapper"
          error={categoryStore.fetchCategoriesError}
          errorMessage="Sorry, an error occurred while trying to load the page."
          loaderFactory={(): JSX.Element => (
            <div className="app-loader-wrapper">
              <LoadingSpinner />
            </div>
          )}
          loading={categoryStore.fetchingCategories}
          pageUrl={this.props.match.url}
        >
          <div className="layout-body-wrapper">
            <NavigationContainer />
            <div className="layout-body">
              <SiteBanner />
              {this.props.children}
            </div>
          </div>
        </AsyncLoader>
        <Footer />
        <Notifications notifications={notificationStore.notifications} />
        {this.renderDevTool()}
      </div>
    );
  }

  private onBodyClick = (event: React.MouseEvent<HTMLElement>) => {
    this.hideNavOnBodyClick(event);
    this.collapseDesktopNavOnBodyClick(event);
  };

  private hideNavOnBodyClick = (event: React.MouseEvent<HTMLElement>) => {
    const navMenuStore = this.props[STORE_NAV_MENU] as NavMenuStore;

    if (!event[EVENT_HANDLED_NAV] && navMenuStore.expanded) {
      navMenuStore.hide();
    }
  };

  private collapseDesktopNavOnBodyClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    const navMenuStore = this.props[STORE_NAV_MENU] as NavMenuStore;

    if (!event[EVENT_HANDLED_NAV] && navMenuStore.desktopExpandedItem) {
      navMenuStore.collapseDesktopNav();
    }
  };

  private renderDevTool = () => {
    const { DevTools } = this.props;

    if (!DevTools) {
      return null;
    }

    return <DevTools />;
  };
}



// WEBPACK FOOTER //
// ./src/app/containers/Layout/index.tsx